import React from 'react';

const NameCell = (props) => {
    if (props.row.isDateRow || props.row.isFilterRow) {
        return null;
    } else {
        return (
            <>
                <div style={{
                    lineHeight: '1.3em',
                    // Strike through names of deleted user
                    textDecoration: (props.row.user?.deleted === 1) ? 'line-through' : 'inherit',
                }}>
                    {props.row.user_name}
                </div>
                <span style={{ fontSize: '0.8em', lineHeight: '0.8em' }}>
                    {props.row.unit_name}
                </span>
            </>
        )
    }
}

export default NameCell;
